import React from 'react';

import { rem } from '@vimeo/bokeh';
import { Text } from '@vimeo/bokeh';
import { Checkmark } from '@vimeo/bokeh-icons';

import { PLANS, PLANS_DISPLAY_NAMES } from '../../../utils/constants';
import { defaultTemplateProps, PlanData } from '../../../utils/interface';
import translations from '../../../utils/translations';
import { getPlanFeaturesList } from '../../../utils/utils';
import { PlansFeaturesContainer, FeatureList, FeaturesWrapper } from './styles';

interface Props {
  modalConfig?: defaultTemplateProps;
  planData: PlanData;
  previousCardPlan: string | null;
}

const PlanCardFeatures = (props: Props) => {
  const featureTitle = props.previousCardPlan
    ? translations.everythingInPlan(PLANS_DISPLAY_NAMES[props.previousCardPlan])
    : translations.keyFeatures;
  const features = getPlanFeaturesList(props.modalConfig, props.planData);
  const tier = props.planData.tier;
  const maxFeatureCount =
    tier === PLANS.ENTERPRISE ? 5 : tier === (PLANS.STARTER || PLANS.PLUS) ? 3 : 4;

  return features && features.length > 0 ? (
    <PlansFeaturesContainer>
      <Text variant={{ base: 'heading-xs', md: 'heading-sm', xl: 'heading-xs' }} fontWeight="600">
        {featureTitle}
      </Text>
      <FeaturesWrapper>
        {features.map((feature: string, index: number) => {
          if (index < maxFeatureCount) {
            return (
              <FeatureList key={`${tier}-feature-${index}`}>
                <div>
                  <Checkmark height={rem(16)} width={rem(16)} />
                </div>
                <Text variant={{ base: 'body-md', md: 'body-lg', xl: 'body-md' }}>{feature}</Text>
              </FeatureList>
            );
          }
        })}
      </FeaturesWrapper>
    </PlansFeaturesContainer>
  ) : null;
};

export default PlanCardFeatures;
